import get from 'lodash/get'

// Returns name of provided gql query
const getNameOfGqlQuery = query => {
	const appFieldList = ['cashAssist', 'fakturaAssist', 'rezeptAssist', 'reports']
	try {
		const selectionSet = get(query, 'definitions[0].selectionSet')
		const getName = set => {
			const { name = {}, selectionSet: nestedSet } = get(set, 'selections[0]', {})
			return appFieldList.includes(name.value) ? getName(nestedSet) : name.value
		}
		return getName(selectionSet)
	} catch(err) {
		return null
	}
}

export default getNameOfGqlQuery
